export enum HEATMAP_DOWNLOAD_TYPES {
  CSV = 'csv',
  JPG = 'jpg',
}
